define(
({
  "alert": "警报",
  "okay": "好"
})
);
